/* FORMA 2.0: tallas en la tarjeta, ficha sin talla marcada, barra fija y personita de ayuda. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* 1. Tallas en la tarjeta: un toque agrega la talla y abre el carrito */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-forma-variant]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    agregar(btn);
  });

  function agregar(btn) {
    var wrap = btn.closest('.forma-tallas');
    var msg = wrap && wrap.parentElement ? wrap.parentElement.querySelector('.forma-tallas__msg') : null;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var id = Number(btn.dataset.formaVariant);
    var body = { id: id, quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }
    if (msg) msg.textContent = '';
    btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (msg) msg.textContent = data.description || data.message || 'No se pudo agregar. Intenta de nuevo.';
          return;
        }
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'forma-tallas', productVariantId: id, cartData: data });
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () { if (msg) msg.textContent = 'Sin conexion. Intenta de nuevo.'; })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }

  /* 2. Ficha: ninguna talla viene marcada (salvo que la URL traiga ?variant=) */
  function initFicha() {
    var info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!info) return;
    document.body.classList.add('forma-en-ficha');
    var sec = info.dataset.section;
    var form = document.getElementById('product-form-' + sec);
    var selects = info.querySelector('variant-selects');

    if (selects && !/[?&]variant=/.test(window.location.search)) {
      var grupos = Array.prototype.filter.call(selects.querySelectorAll('fieldset'), function (fs) {
        return fs.querySelectorAll('input[type="radio"]').length > 1;
      });
      if (grupos.length) {
        grupos.forEach(function (fs) {
          fs.querySelectorAll('input[type="radio"]').forEach(function (i) { i.checked = false; });
        });
        info.classList.add('forma-sin-talla');
        var add = form && form.querySelector('[name="add"]');
        if (add) {
          add.setAttribute('disabled', 'disabled');
          var span = add.querySelector('span');
          if (span) span.textContent = 'Elige tu talla';
        }
        selects.addEventListener('change', function () { info.classList.remove('forma-sin-talla'); }, { once: true });
      }
    }

    if (!form) return;
    var bar = document.createElement('div');
    bar.className = 'forma-barra';
    bar.innerHTML = '<span class="forma-barra__precio"></span><button type="button" class="forma-barra__btn"></button>';
    document.body.appendChild(bar);
    var bp = bar.querySelector('.forma-barra__precio');
    var bb = bar.querySelector('.forma-barra__btn');

    function precio() {
      var p = document.querySelector('#price-' + sec + ' .price');
      if (!p) return '';
      var el = p.classList.contains('price--on-sale') ? p.querySelector('.price__sale .price-item--sale') : p.querySelector('.price__regular .price-item--regular');
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    var pend = false;
    function sync() {
      pend = false;
      var btn = form.querySelector('[name="add"]');
      var label = btn ? btn.querySelector('span') : null;
      var sinTalla = info.classList.contains('forma-sin-talla');
      bb.textContent = sinTalla ? 'Elige tu talla' : (label ? label.textContent.trim() : 'Agregar al carrito');
      bb.dataset.estado = sinTalla ? 'elegir' : (btn && btn.disabled ? 'agotado' : 'ok');
      bb.disabled = bb.dataset.estado === 'agotado';
      bp.textContent = precio();
    }
    function pedir() { if (!pend) { pend = true; requestAnimationFrame(sync); } }
    bb.addEventListener('click', function () {
      if (info.classList.contains('forma-sin-talla')) {
        (selects || info).scrollIntoView({ behavior: 'smooth', block: 'center' });
        var primera = selects && selects.querySelector('input[type="radio"]:not(.disabled)');
        if (primera) setTimeout(function () { primera.focus({ preventScroll: true }); }, 400);
        return;
      }
      var btn = form.querySelector('[name="add"]');
      if (btn && !btn.disabled) btn.click();
    });
    new MutationObserver(pedir).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    var objetivo = form.querySelector('.product-form__buttons') || form;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-on', !entries[0].isIntersecting);
      }).observe(objetivo);
    }
    sync();
  }

  /* 3. Personita de ayuda */
  function initAyuda() {
    var h = document.querySelector('.forma-ayuda');
    if (!h) return;
    var d = h.querySelector('.forma-ayuda__d');
    if (!d) return;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.open) { d.open = false; d.querySelector('summary').focus(); }
    });
    document.addEventListener('click', function (e) { if (d.open && !h.contains(e.target)) d.open = false; });
    var visto = null;
    try { visto = sessionStorage.getItem('forma-ayuda'); sessionStorage.setItem('forma-ayuda', '1'); } catch (err) {}
    if (!visto && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) h.classList.add('is-intro');
  }

  initFicha();
  initAyuda();
})();
